import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
// declare let alertify: any;

@Injectable({
    providedIn: 'root',
})
export class AlertifyService {

constructor(private snackBar: MatSnackBar) { }

    success(message: string) {
        this.snackBar.open(message, '', { duration: 3000, panelClass: ['success-snackbar'] });
    }

    error(message: string) {
        this.snackBar.open(message, '', { duration: 3000, panelClass: ['error-snackbar'] });
    }

    warning(message: string) {
        this.snackBar.open(message, '', { duration: 3000, panelClass: ['warning-snackbar'] });
    }

    message(message: string) {
        this.snackBar.open(message, '', { duration: 3000, panelClass: ['success-snackbar'] });
    }
}
